import {getStabilityRuleFormDefaultValues} from '@/modules/drug-catalog/stability-rules/functions'
import {LuDroplets, LuLightbulbOff, LuPackageCheck, LuSnowflake, LuSunSnow, LuThermometer} from 'react-icons/lu'
import {SubmitEvent} from 'react'

// Min/Max temperature are hidden on the form for now (CY-80) but kept in the data model.
export const showStorageTemperatureFields = false

export const storageConditionsFields = [
  'lightProtectionRequired',
  'moistureProtectionRequired',
  'doNotRefrigerate',
  'doNotFreeze',
  'controlledTemperature',
  'keepInOriginalPackaging',
] as const

export const StorageConditionsContentMap = {
  lightProtectionRequired: {label: 'light_protection', icon: LuLightbulbOff},
  moistureProtectionRequired: {label: 'moisture_protection', icon: LuDroplets},
  doNotRefrigerate: {label: 'do_not_refrigerate', icon: LuSunSnow},
  doNotFreeze: {label: 'do_not_freeze', icon: LuSnowflake},
  controlledTemperature: {label: 'temp_controlled', icon: LuThermometer},
  keepInOriginalPackaging: {label: 'keep_in_original_pkg', icon: LuPackageCheck},
} as const

interface StabilityRuleFormFieldsProps {
  onCancel?: VoidFunction
}

interface StabilityRuleFormDialogProps extends StabilityRuleFormFieldsProps {
  onSubmit: (event: SubmitEvent<HTMLFormElement>) => void
  title: string
  description: string
}

export const StabilityRuleFormFieldsOptions = {
  defaultValues: getStabilityRuleFormDefaultValues(undefined),
  props: {} as StabilityRuleFormFieldsProps,
}

export const StabilityRuleFormDialogOptions = {
  defaultValues: getStabilityRuleFormDefaultValues(undefined),
  props: {
    ...StabilityRuleFormFieldsOptions.props,
    onSubmit: (_event: SubmitEvent<HTMLFormElement>) => {},
    title: '',
    description: '',
  } as StabilityRuleFormDialogProps,
}
